export default __webpack_public_path__ + "static/joko-app-screenshot-home-4-en@2x-7a4456432759df71d9658865d59a9ef8.webp";